import Vue from 'vue';
import siteConfiguration from '@/config';

export function getLatestPosts() {
  return new Promise((resolve, reject) => {
    Vue.jsonp(siteConfiguration.BLOG_API_URL + "?json=get_recent_posts", {
      callback: 'JSON_CALLBACK'
    }).then(response => {
      resolve(response);
    }, error => {
      reject(error);
    });
  });
};



// WEBPACK FOOTER //
// ./src/services/BlogService.js